<template>
  <div class="">
    <div class="error404 text-center">
      <div class="container-fluid error-content">
        <div class="logo">
          <img alt="logo" class="navbar-logo" :src="'/assets/images/logo_studea.png'" />
        </div>
        <FontAwesomeIcon :icon="'fa-light fa-' + (isProcessing ? 'ellipsis' : 'check')" />
        <h2>
          {{ $t("page.download." + (isProcessing ? "processing" : "success")) }}
        </h2>
      </div>
    </div>
  </div>
</template>

<script>
import { useMainStore } from "@/store/main/main";
import { fileManager } from "@/services/file/file-manager";

export default {
  name: "DownloadView",
  data() {
    return {
      isProcessing: true,
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      const { action, base64file, fileName } = this.$route.params;
      const url = "/app/files/token/" + action + "/" + base64file + "-" + fileName;
      fileManager.generateFileTokenFromApi(url).then((res) => {
        fileManager.downloadFileFromUrlWithToken(res.url);
        this.isProcessing = false;
        useMainStore().setAppLoading(false);
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.error404 {
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='100%25' height='100%25' viewBox='0 0 800 400'%3E%3Cdefs%3E%3CradialGradient id='a' cx='396' cy='281' r='514' gradientUnits='userSpaceOnUse'%3E%3Cstop offset='0' stop-color='%23e6e6e6'/%3E%3Cstop offset='1' stop-color='%23eaf1ff'/%3E%3C/radialGradient%3E%3ClinearGradient id='b' gradientUnits='userSpaceOnUse' x1='400' y1='148' x2='400' y2='333'%3E%3Cstop offset='0' stop-color='%234361ee' stop-opacity='0'/%3E%3Cstop offset='1' stop-color='%234361ee' stop-opacity='0.5'/%3E%3C/linearGradient%3E%3C/defs%3E%3Crect fill='url(%23a)' width='800' height='400'/%3E%3Cg fill-opacity='0.5'%3E%3Ccircle fill='url(%23b)' cx='267.5' cy='61' r='300'/%3E%3Ccircle fill='url(%23b)' cx='532.5' cy='61' r='300'/%3E%3Ccircle fill='url(%23b)' cx='400' cy='30' r='300'/%3E%3C/g%3E%3C/svg%3E");
  background-size: cover;
  background-color: #fff;
  background-position: center;
  height: 100vh;
  position: fixed;
  width: 100vw;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  @include mobile {
    padding: 0 15px;
  }
  .logo {
    margin-bottom: 40px;
    max-width: 100%;

    img {
      width: 100%;
    }
  }

  > .error-content {
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    flex-direction: column;
    height: 100%;

    svg {
      width: 120px;
      height: auto;
      color: $blue;

      @include up-to-lg {
        width: 80px;
      }
    }
  }

  h2 {
    height: auto;
    color: $blue;
    font-size: 30px;
    margin-top: 30px;

    @include up-to-lg {
      font-size: 20px;
      margin-bottom: 30px;
    }
  }
}
</style>
